import {Component, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {AppRoutingUtil} from 'src/app/util/app-routing-util';
import {ActivatedRoute} from '@angular/router';
import {Auth} from "aws-amplify";
import {ResendCodeComponent} from "../resend-code/resend-code.component";

@Component({
  selector: 'app-verification-code',
  templateUrl: './account-view-verification-code.component.html',
  styleUrls: ['./account-view-verification-code.component.scss'],
})
export class AccountViewVerificationCodeComponent implements OnInit {
  codeSent: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
              private navCtrl: NavController) {
  }

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe((result) => {
      this.codeSent = result['codeSent'];
    });
  }

  async sendCode() {
    await Auth.verifyCurrentUserAttribute(ResendCodeComponent.COGNITO_PHONE_NUMBER_ATTRIBUTE);
    await this.navCtrl.navigateForward(AppRoutingUtil.ACCOUNT_VERIFICATION_CODE, {queryParams: {codeSent: true}});
  }

  async toHome() {
    this.navCtrl.navigateRoot('/', { skipLocationChange: true }).then(() =>
      this.navCtrl.navigateForward(AppRoutingUtil.DASHBOARD));
  }
}
